import React from 'react';

import { SVGComponentProps } from './svg.types';

const ChatSVG = ({
  stroke = 'currentColor',
  size = '1em',
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className="inline-block">
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M9.88236 5.76491C9.88398 6.38602 9.73887 6.99873 9.45883 7.55314C9.1268 8.21749 8.61636 8.77628 7.98469 9.16692C7.35302 9.55756 6.62506 9.76462 5.88236 9.76491C5.26125 9.76653 4.64853 9.62141 4.09413 9.34138L1.41177 10.2355L2.30589 7.55314C2.02586 6.99873 1.88074 6.38602 1.88236 5.76491C1.88265 5.0222 2.08971 4.29425 2.48035 3.66258C2.87099 3.03091 3.42978 2.52047 4.09413 2.18844C4.64853 1.9084 5.26125 1.76329 5.88236 1.76491H6.11766C7.09853 1.81902 8.02497 2.23303 8.7196 2.92766C9.41424 3.6223 9.82825 4.54874 9.88236 5.52961V5.76491Z"
          stroke={stroke}
          strokeWidth="0.705882"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default ChatSVG;
